import * as React from "react";
import SEO from "../components/seo";
import Layout from "../components/layout";
import SimpleHero from "../components/v2/simple-hero";
import HeadlineBanner from "../components/v2/headline-banner";
import FiftyFiftyHorizontal from "../components/v2/fifty-fifty-horizontal";
import ImageComparison from "../components/v2/image-comparison";
import ImageGridBanner from "../components/v2/image-grid-banner";
import MediaSlider from "../components/v2/media-slider";
import ContentBanner from "../components/v2/content-banner";
import GetUpdates from "../components/v2/get-updates";
import DetailsFooter from "../components/v2/details-footer";
import Quote from "../components/v2/quote";
import YoutubeVideo from "../components/v2/youtube-video";

// Hooks
import useAllTogetherSkateParkPageImages from "../hooks/useAllTogetherSkatePark";
import ArrowLink from "../components/global/arrow-link";

const AllTogetherSkatePark = () => {
  return (
    <Layout
      className="template-details"
      bodyTheme="light"
      isFooter={false}
      headerLayout="mobile"
    >
      <SEO title="All Together Skatepark" />
      <SimpleHero
        contentData={
          {
            pre_title: "All together",
            title: "Skatepark",
          }
        }
        imageData={useAllTogetherSkateParkPageImages({name: "all-together-skatepark-1"})}
      />
      <HeadlineBanner
        className="spacing spacing--general"
        pre_title="Designed by skaters"
        title="For all skaters"
      />
      <YoutubeVideo
        className="spacing spacing--general"
        youtubeId="mRa-EoaTqFs"
      />
      <FiftyFiftyHorizontal
        imageData={useAllTogetherSkateParkPageImages({name: "all-together-skatepark-2"})}
      >
        <p>All Together Skatepark Salt Lake is evo’s second ATS location. This 5,000 square-foot indoor/outdoor skatepark has been designed specifically to facilitate progression. It offers a rad experience for skaters of all ages and ability levels.</p>
        <p className="flex-copy">
          <span>Open daily, 10AM-7PM</span>
          <span><a className="dark" href="tel: +1 (385) 379-3172">(385) 379-3172</a></span>
          <span>
            <ArrowLink
              isExternalLink={true}
              to="https://www.alltogetherskatepark.com/ats-salt-lake/"
              text="Learn More"
              theme="dark-body"
            />
          </span>
        </p>
      </FiftyFiftyHorizontal>
      <ImageComparison
        className="spacing spacing--general"
        generalImage={useAllTogetherSkateParkPageImages({name: "all-together-skatepark-3"})}
      />
      <HeadlineBanner
        className="spacing spacing--general"
        pre_title="Created in"
        title="Familiar company"
      />
      <FiftyFiftyHorizontal
        mediaPosition="left"
        contentColumns={5}
        contentOffset={1}
        mediaColumns={6}
        mediaOffset={0}
        imageData={useAllTogetherSkateParkPageImages({name: "all-together-skatepark-4"})}
      >
        <Quote
          quote="See and feel the energy,  it’s a place for all ages, all people, all abilities.”"
          author="Bryce Phillips,"
          position="Founder and CEO of evo"
        />
      </FiftyFiftyHorizontal>
      <ImageGridBanner
        className="spacing spacing--spacing-3"
        imageData={useAllTogetherSkateParkPageImages({name: "all-together-skatepark-5"})}
      />
      <FiftyFiftyHorizontal
        contentColumns={5}
        contentOffset={1}
        mediaColumns={5}
        mediaOffset={1}
        imageData={useAllTogetherSkateParkPageImages({name: "all-together-skatepark-13"})}
      >
        <p>ATS Salt Lake was designed by Seattle skateboarding legend Marshall Reid in partnership with Ryan Spence from 5th Floor Ramp Designs in Tacoma, Washington.</p>
        <p>Featuring wood and Skatelite surfaces, ATS includes flat banks, quarter pipes, a half pipe, ledges, flat bar and more.</p>
      </FiftyFiftyHorizontal>
      <ContentBanner
        className="spacing spacing--general"
        title="About Marshall Reid"
        description="Marshall “Stack” Reid is an iconic figure in the Seattle skateboarding scene. For more than 25 years, he’s organized skate competitions, worked in skate shops, taught skate camps, started skate companies and been an advocate for the skateboarding community. Marshall was the driving force behind the creation of ATS Seattle, and he’s served as the general manager there since it opened in 2013."
      />
      <MediaSlider
        className="spacing spacing--general"
        slides={[
          {
            imageData: useAllTogetherSkateParkPageImages({name: "all-together-skatepark-6"}),
            description: "",
          },
          {
            imageData: useAllTogetherSkateParkPageImages({name: "all-together-skatepark-7"}),
            description: "",
          },
          {
            imageData: useAllTogetherSkateParkPageImages({name: "all-together-skatepark-8"}),
            description: "",
          },
          {
            imageData: useAllTogetherSkateParkPageImages({name: "all-together-skatepark-9"}),
            description: "",
          },
          {
            imageData: useAllTogetherSkateParkPageImages({name: "all-together-skatepark-10"}),
            description: "",
          },
        ]}
      />
      <GetUpdates
        className="spacing spacing--general"
      />
      <DetailsFooter
        imageData={useAllTogetherSkateParkPageImages({name: "all-together-skatepark-11"})}
        imageDataHover={useAllTogetherSkateParkPageImages({name: "all-together-skatepark-12"})}
        linkData={{
          title: "Read Story",
          project_url: "/level-nine-sports/",
        }}
        pre_title="Up Next"
        title="Level 9 Sports"
      />
    </Layout>
  )
}

export default AllTogetherSkatePark
